import React, { useEffect, useState } from "react";
import { Config } from "../../configurations/config";
import axios from "axios";
import { Table } from "reactstrap";
import moment from "moment";
import "./employeeLeave.scss";
import PageLoader from "../../components/PageLoader";
function EmployeeStatus({ token, projectId }) {
	const [statusData, setStatusData] = useState({});
	const [loading, setLoading] = useState(true);
	useEffect(() => {
		axios
			.get(
				`${Config.server_url}${Config.api_prefix}/Project/${projectId}/GetProjectEmployees`,
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then((res) => {
				setStatusData(res.data);
				setLoading(false);
			});
	}, [projectId, token]);
	const employeeStatus = {
		1: {
			title: "Working",
			className: "badge-success",
		},
		2: {
			title: "Waiting For Work",
			className: "badge-warning",
		},
		3: {
			title: "Need help",
			className: "badge-danger",
		},
	};
	return loading ? (
		<PageLoader />
	) : (
		<div style={{ marginTop: "20px" }}>
			<Table borderless responsive className="leaveManagementTable">
				<thead className="tableHeader">
					<tr className="text-center">
						<th className="text-justify">Employee Name</th>
						<th>Designation</th>
						<th>Development Center</th>
						<th>Work Status</th>
						<th>Work Status Time</th>
					</tr>
					<tr className="text-center availedThead"></tr>
				</thead>
				<tbody>
					{statusData?.map((data, index) => {
						const { workingStatus } = data;
						return (
							<tr
								key={index}
								className={`text-center ${
									index % 2 === 0 ? "row1" : "row2"
								}`}
							>
								<td className="text-justify text-bold">
									{data.empName}
								</td>
								<td>{data.empDesignation}</td>
								<td>DC{data.empDevelopmentCenter}</td>
								{workingStatus ? (
									<td>
										<span
											class={`statusbadge badge-pill ${
												employeeStatus[
													workingStatus.status
												].className
											}`}
										>
											{
												employeeStatus[
													workingStatus.status
												].title
											}
										</span>
									</td>
								) : (
									<td>None</td>
								)}
								<td>
									{workingStatus
										? moment(
												workingStatus.createdAt
										  ).format("DD/MM/YYYY HH:mm:ss")
										: "None"}
								</td>
							</tr>
						);
					})}
				</tbody>
			</Table>
		</div>
	);
}

export default EmployeeStatus;
